import superjson from "superjson";
import { SuperJSONValue } from "superjson/dist/types";

export function jsonSerialize<T>(data: T): SuperJSONValue | null {
  if (typeof data === "undefined") {
    return null;
  }

  return superjson.serialize(data);
}

export function jsonDeserialize<T>(data: SuperJSONValue): T {
  if (!data || !("json" in data)) {
    return data;
  }
  return superjson.deserialize(data);
}
